import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewChildren, QueryList, OnDestroy, AfterViewInit, AfterViewChecked, ElementRef, HostListener } from '@angular/core';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'underscore'
import Swal from 'sweetalert2';
import { reportDataTableSortableDirective, SortEvent } from './report-datatable-sortable.directive';
import { P_CampaignStageTitle, P_RolesName_Filter, CleanupCampaignPipe, NumberPipe, PercentPipe, P_AppDateFormat } from '../../shared.pipe';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppService } from '../../../store/app.service';
import { ExportToCsv } from 'export-to-csv';
import * as lodash from 'lodash'
import { PAGE_NAMES, ROLES } from '../../../core/helpers/constants';
import { LoadDataFromServer, sortDirection } from '../datatable/datatable.model';
import { DomSanitizer } from '@angular/platform-browser';
import { UsersService } from '../../../pages/users/users.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-report-datatable',
  templateUrl: './report-datatable.component.html',
  styleUrls: ['./report-datatable.component.scss'],
  providers: [CurrencyPipe, DecimalPipe, P_CampaignStageTitle, P_RolesName_Filter, CleanupCampaignPipe, NumberPipe, PercentPipe]
})

/**
 * Datatable Component
 */

export class ReportDatatableComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  PAGE_NAMES = PAGE_NAMES;
  @ViewChildren(reportDataTableSortableDirective)
  headers!: QueryList<reportDataTableSortableDirective>;

  @ViewChildren('summaryRow', { read: ElementRef })
  summaryRows!: QueryList<ElementRef<HTMLTableRowElement>>;

  @ViewChild('reportTable', { read: ElementRef })
  reportTable!: ElementRef<HTMLTableElement>;

  dtForm: FormGroup;
  collectionSize: number = 0;

  activePage = '';
  //activeUser = {} as IUser;
  @Input() isAdmin: boolean = false;
  @Input() iCanRead: boolean = true;
  pageNumber = 1;
  @Input() iActiveUserId: string | undefined = '';

  @Input() iHideHeaderActions: boolean = false;
  @Input() iShowExport: boolean = true;
  @Input() iShowHeader: boolean = true;
  @Input() iShowPagination: boolean = true;
  @Input() iShowFooter: boolean = true;
  @Input() iShowExternalAction: boolean = false;
  @Input() iStickyHeader: boolean = false;

  @Input() iShowActions: boolean = false;
  @Input() iShowViewAction: boolean = false;

  @Input() iShowSearch: boolean = true;
  
  @Input() set iPageSize(value: number) {
    this.dtForm.patchValue({ pageSize: value || 25 });
    this.pageSize = value || 25;
    this.formPageSize = value || 25;
    this.prepareData();
  }
  
  // @Input() iPageSize = 25;

  @Input() iUserRoles: Array<number> = [];
  @Input() iSortDirection = 'asc';
  @Input() iSortColumn = 'name';
  @Input() iSortColumnProps = {} as any;
  @Input() iIsServerLoading = false;
  @Input() iIsCustomDataExport = false;
  @Input() iIsExportFilter = false;
  @Input() iDateField = '';
  @Input() iReportTitle = '';
  
  @Input() iColumns: Array<any> = [];
  @Input() set iData$(data: Array<any>) {
    this.rawData = data || [];
    this.safeHtmlCache.clear();
    this.removeStickyHeaderClone();
    this.prepareData();
  }
  @Input() set iTotalCount(totalCount: number) {
    this.totalCount = totalCount;
    this.prepareData();
  }
  @Input() iTotalData: Array<any> = [];
  @Input() iAverageData: Array<any> = [];
  /*
  @Input() set iTotalData$(totalData: Array<any>) {
    this.totalData = totalData || [];
    // this.prepareData();
  }
  @Input() set iAverageData$(averageData: Array<any>) {
    this.averageData = averageData || [];
    // this.prepareData();
  }
    */
  @Input() iRowLinkHandler?: Function = undefined;

  @Output() oViewRow = new EventEmitter<any>();
  @Output() oShowExternal = new EventEmitter<any>();
  @Output() oRowClick = new EventEmitter<any>();
  @Output() oLoadDataFromServer = new EventEmitter<any>();
  @Output() oCustomDataExport = new EventEmitter<any>();
  @Output() oVisibleDataChange = new EventEmitter<Array<any>>();
  
  rawData: Array<any> = new Array<any>();
  viewData: Array<any> = new Array<any>();
  private safeHtmlCache = new Map<string, any>();
  totalCount: number = 0;
  totalData: Array<any> = new Array<any>();
  averageData: Array<any> = new Array<any>();
  tooltipText: string = '';
  formPageSize: number = 25;
  pageSize: number = 25;
  private summaryRowSyncFrame: number | null = null;
  private stickyHeaderClone: HTMLTableElement | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private appService: AppService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private uService: UsersService,
    private cleanupCampaignPipe: CleanupCampaignPipe,
  ) {

    this.dtForm = this.formBuilder.group({
      pageSize: this.formPageSize,
      activePage: this.pageNumber,
      searchQuery: '',
      startDate: [null],
      endDate: [null],
    });

    this.dtForm.get("searchQuery")
      ?.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe(text => {
        if (!this.iIsServerLoading) {
          this.prepareData();
        }
      });

    this.appService.getActivePage$().subscribe(p => {
      this.activePage = p;
    });
  }

  get f() { return this.dtForm.controls; }
  ngOnInit(): void {
    this.pageSize = this.formPageSize;
    this.dtForm.get('pageSize')?.setValue(this.pageSize);
    this.loadData();
    this.totalData = this.iTotalData;
    this.averageData = this.iAverageData;
  }

  ngAfterViewInit(): void {
    this.scheduleSummaryRowSync();
    this.syncStickyHeader();
  }

  ngAfterViewChecked(): void {
    this.scheduleSummaryRowSync();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleSummaryRowSync();
    this.syncStickyHeader();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.syncStickyHeader();
  }

  private syncStickyHeader(): void {
    const table = this.reportTable?.nativeElement;
    const header = table?.tHead;
    if (!table || !header) {
      return;
    }

    if (!this.iStickyHeader) {
      this.removeStickyHeaderClone();
      return;
    }

    const tableRect = table.getBoundingClientRect();
    const headerHeight = header.getBoundingClientRect().height;
    const shouldFixHeader = tableRect.top <= 0
      && tableRect.bottom > headerHeight;

    if (!shouldFixHeader) {
      this.removeStickyHeaderClone();
      return;
    }

    if (!this.stickyHeaderClone) {
      const clone = table.cloneNode(false) as HTMLTableElement;
      clone.removeAttribute('id');
      clone.classList.add('report-datatable-table--sticky-clone');

      const colgroup = table.querySelector('colgroup');
      if (colgroup) {
        clone.appendChild(colgroup.cloneNode(true));
      }

      const clonedHeader = header.cloneNode(true) as HTMLTableSectionElement;
      clonedHeader.classList.add('report-datatable-table__header--fixed');
      clone.appendChild(clonedHeader);
      document.body.appendChild(clone);
      this.stickyHeaderClone = clone;
    }

    const cloneHeader = this.stickyHeaderClone.tHead;
    if (!cloneHeader) {
      return;
    }

    const headerWidths = Array.from(header.querySelectorAll<HTMLElement>('th'))
      .map(cell => cell.getBoundingClientRect().width);
    cloneHeader.querySelectorAll<HTMLElement>('th').forEach((cell, index) => {
      if (headerWidths[index]) {
        cell.style.width = `${headerWidths[index]}px`;
      }
    });
    this.stickyHeaderClone.style.position = 'fixed';
    this.stickyHeaderClone.style.top = '0px';
    this.stickyHeaderClone.style.left = `${tableRect.left}px`;
    this.stickyHeaderClone.style.width = `${tableRect.width}px`;
    this.stickyHeaderClone.style.zIndex = '3';
    this.stickyHeaderClone.style.background = 'var(--details-records-bg)';
  }

  private removeStickyHeaderClone(): void {
    this.stickyHeaderClone?.remove();
    this.stickyHeaderClone = null;
  }

  onPageSizeChange(evt: any) {
    this.pageSize = evt;
    this.dtForm.get('pageSize')?.setValue(this.pageSize, { emitEvent: false });
    this.loadData();
    this.prepareData();
  }

  onPageChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.loadData();
    this.prepareData();
  }

  /**
  * Creates an array of data to CSV. It will automatically generate a title row based on object keys.
  *
  * @param rows array of data to be converted to CSV.
  * @param fileName filename to save as.
  * @param columns array of object properties to convert to CSV. If skipped, then all object properties will be used for CSV.
  **/
  exportToCsv() {
    if (this.iIsCustomDataExport === true) {
      if(this.iIsExportFilter == false){
        this.oCustomDataExport.emit();
      }
      else{
        const event: LoadDataFromServer = {
          pageSize: this.f.pageSize.value,
          pageNumber: this.pageNumber,
          sortColumn: this.iSortColumn,
          sortDirection: this.iSortDirection === 'asc' ? sortDirection.asc : sortDirection.desc,
          search: this.f?.searchQuery?.value,
          startDate: this.f?.startDate?.value,
          endDate: this.f?.endDate?.value
        }
        this.oCustomDataExport.emit(event);
      }
      return;
    }
    let title = this.appService.getPageTitle$().getValue();

    var filtered: Array<any> = [];
    if (this.checkedItemsCount >= 1) {
      /* select checked data */
      for (var i = 0; i < this.viewData.length; i++) {
        if (this.viewData[i].isSelected)
          filtered.push(this.viewData[i]);
      }
      /* end select checked data */
    }
    else {
      /* filter data */
      var query = this.f?.searchQuery?.value;
      if (query != null) {
        if (query === '') {
          filtered = this.rawData
        }
        else {
          filtered = this.search(query, null, null);
        }
      }
      /* end filter data */
    }

    /* prepare data, remove null amd undefined values */
    var exportData: Array<any> = [];
    filtered
      .forEach((row: any) => {
        let obj: any = {};
        this.iColumns
          .forEach((col: any) => {
            const exportField = col.exportField || col.field;
            let value = this.extractFieldValue(row, exportField, col.pipe, col?.pipeArgs);
            const header = col.title ? this.translate.instant(col.title) : col.field;
            if (col.translate && typeof value === 'string') {
              value = this.translate.instant(value);
            }
            if (value && value !== null && value !== undefined) {
              obj[header] = value;
            }
            else {
              obj[header] = '';
            }
          });
        exportData.push(obj);
      });
    /* end prepare data, remove null amd undefined values */

    /* export prepared data to csv */
    const options = {
      filename: title,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      title: title,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(exportData);
    /* end export prepared data to csv */
  }

  filterData(array: Array<any>) {
    var query = this.f?.searchQuery?.value;
    var fromDate = this.f?.startDate?.value || null;
    var toDate = this.f?.endDate?.value || null;
    var dataset = array;
    if ((query != null && query !== '') || fromDate != null || toDate !=null) {
      dataset = this.search(query, fromDate, toDate);
    }
    else {
      dataset = this.rawData
    }
    return dataset;
  }

  paginate(array: Array<any>, pageSize: number, pageNumber: number) {
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  }

  onCbHeadChange(evt: any) {
    for (var i = 0; i < this.viewData.length; i++) {
      this.viewData[i].isSelected = evt.target.checked;
    }
  }

  viewRow(evt: any) {
    this.oViewRow.emit(evt);
  }

  showExternal(evt: any) {
    this.oShowExternal.emit(evt);
  }

  get checkedItemsCount() { return this.getCheckedItemsIds().length; }

  getCheckedItemsIds() {
    const checkedList = new Array<string>();
    for (var i = 0; i < this.viewData.length; i++) {
      if (this.viewData[i].isSelected)
        checkedList.push(this.viewData[i].id);
    }
    return checkedList;
  }

  onSort({ column, direction }: SortEvent, colProps: any) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.iSortColumn = column;
    this.iSortColumnProps = colProps;
    this.iSortDirection = direction;
    this.loadData();
    this.prepareData();
  }

  loadData() {
    if (this.iIsServerLoading) {
      const event: LoadDataFromServer = {
        pageSize: this.f.pageSize.value,
        pageNumber: this.pageNumber,
        sortColumn: this.iSortColumn,
        sortDirection: this.iSortDirection === 'asc' ? sortDirection.asc : sortDirection.desc,
        search: this.f?.searchQuery?.value,
        startDate: this.f?.startDate?.value,
        endDate: this.f?.endDate?.value
      }
      this.oLoadDataFromServer.emit(event);
    }
  }

  prepareData() {
    if (this.iIsServerLoading) {
      this.viewData = this.rawData;
      this.collectionSize = this.totalCount;
    } else {
      let viewData = this.rawData || [];
      viewData = this.filterData(viewData);
      viewData = [...this.sort(viewData)];
      this.collectionSize = viewData.length;
      viewData = [...this.paginate(viewData, this.f.pageSize.value, this.pageNumber)];
      this.viewData = viewData;
    }
    this.oVisibleDataChange.emit(this.viewData);
  }

  sort(tables: any[]): any[] {
    if (!tables || tables.length === 0) return tables;
    const sortColumns = this.iSortColumn ? this.iSortColumn.split(',') : [];
    const direction = this.iSortDirection;
    if (direction === '' || sortColumns.length === 0) return tables;
    const pipes: any[] = [];
    const pipeArgs: any[] = [];
    for (let index = 0; index < sortColumns.length; index++) {
      const sortColumn = sortColumns[index];
      const column = this.getColumnByField(sortColumn);
      if (column === undefined) {
        return tables;
      }
      if (column.pipe !== undefined) {
        const pipe = this.appService?.getPipeByName(column.pipe);
        pipes.push(pipe);
        pipeArgs.push(column.pipeArgs || []);
      } else {
        pipes.push(null);
        pipeArgs.push([]);
      }
    }
    return [...tables].sort((a, b) => {
      let valueA: any[] = [];
      let valueB: any[] = [];
      for (var i = 0; i < sortColumns.length; i++) {
        if (pipes[i] !== null) {
          let transformedA = pipes[i].transform(a[sortColumns[i]], ...pipeArgs[i]);
          let transformedB = pipes[i].transform(b[sortColumns[i]], ...pipeArgs[i]);
          if (pipes[i] instanceof NumberPipe || pipes[i] instanceof PercentPipe || pipes[i] instanceof CurrencyPipe) {
            transformedA = parseFloat(transformedA.replace(/[^0-9.-]+/g, ""));
            transformedB = parseFloat(transformedB.replace(/[^0-9.-]+/g, ""));
          } else if (pipes[i] instanceof P_AppDateFormat) {
            transformedA = new Date(a[sortColumns[i]]);
            transformedB = new Date(b[sortColumns[i]]);
          }
          valueA.push(transformedA);
          valueB.push(transformedB);
        } else {
          valueA.push(a[sortColumns[i]]);
          valueB.push(b[sortColumns[i]]);
        }
      }
      const res = this.compare(valueA, valueB);
      return direction === 'asc' ? res : -res;
    });
  }

  compare = (a: any[], b: any[]) => {
    if (a.length !== b.length) return 0;
    for (var i = 0; i < a.length; i++) {
      let valueA = a[i];
      let valueB = b[i];
      if (this.isString(valueA)) valueA = valueA.toLowerCase();
      if (this.isString(valueB)) valueB = valueB.toLowerCase();
      if (valueA !== valueB) {
        return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
      }
    }
    return 0;
  }



  search(query: string, fromDate: any, toDate: any) {    
    let r = new Array<any>();
    for (var ele of this.rawData) {
      for (let col of this.iColumns.filter(x => (x.searchable && x.searchable === true))) {
        let value = ele[col.field];

        if (value == null || value == undefined)
          continue;

        if (col.pipe !== undefined) {
          const pipe: any = this.appService?.getPipeByName(col.pipe);
          value = pipe?.transform(ele[col.field], col.pipeArgs);

          if (value == null || value == undefined)
            continue;
        }

        if (col.field === 'campaignName') {
          value = this.cleanupCampaignPipe.transform(value);
        }

        if (value.toString().toLowerCase().indexOf(query.toLowerCase()) > -1) {
          if(fromDate != null || toDate != null){
            var fdate;
            if(typeof new Date(value).getMonth === 'function'){
              fdate = new Date(value);
            }
            else{
              const [month, day, year] = ele[this.iDateField].split('/');
              fdate = new Date(+year, +month - 1, +day);
            }
            
            if(fromDate != null && toDate != null){
              if(fdate >= fromDate && fdate <= toDate){
                r.push(ele);
                break;
              }
            }
            else if(fromDate != null){
              if(fdate >= fromDate){
                r.push(ele);
                break;
              }
            }
            else{
              if(fdate <= toDate){
                r.push(ele);
                break;
              }
            }
          }
          else{
            r.push(ele);
            break;
          }
        }
      }
    }
    return r;
  }

  extractFieldValue(row: any, colName: string, pipe: string, pipeArgs: any[] = []): any {
    let value = lodash.get(row, colName);
    if (pipe) {
      if (pipe === 'cleanupCampaign') {
        value = this.cleanupCampaignPipe.transform(value);
      } else {
        const p: any = this.appService?.getPipeByName(pipe);
        value = p?.transform(value, ...(pipeArgs || []));
      }
    }
    return value;
  }

  getAnchorLink(type: string, param: any) {
    switch (type) {
      case 'client':
        return '/pages/client-details/' + param;
      case 'campaign':
        return '/pages/campaign-details/' + param;
      case 'report':
        return '/pages/reports/view-report/' + param;
      case 'subscription':
        return '/pages/subscriptions/' + param;
      case 'order':
        return '/pages/orders/details/' + param;
      default:
        return '';
    }
  }

  ngOnDestroy(): void {
    this.iStickyHeader = false;
    this.syncStickyHeader();
    if (this.summaryRowSyncFrame !== null) {
      window.cancelAnimationFrame(this.summaryRowSyncFrame);
      this.summaryRowSyncFrame = null;
    }
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  doServerSearch(event: any) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.iIsServerLoading) return;
    this.loadData();
  }

  SafeHtml(str: string) {
    if (!str) {
      return '';
    }

    const cachedHtml = this.safeHtmlCache.get(str);
    if (cachedHtml) {
      return cachedHtml;
    }

    const trustedHtml = this.sanitizer.bypassSecurityTrustHtml(str);
    this.safeHtmlCache.set(str, trustedHtml);
    return trustedHtml;
  }

  SafeUrl(str: string) {
    return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + str);
  }

  getColumnByField(fieldName: string) {
    return this.iColumns.find(x => x.field === fieldName);
  }

  getRowLink(row: any) {
    if (this.iRowLinkHandler === undefined) return { routerLink: null, queryParams: null };
    const link = this.iRowLinkHandler.call(null, row);
    const linkParts = link.split('?');
    const linkObject: any = { routerLink: linkParts[0], queryParams: {} }
    if (linkParts.length > 1) {
      const queryParams = linkParts[1].split('&');
      for (var i = 0; i < queryParams.length; i++) {
        linkObject.queryParams[queryParams[i].split('=')[0]] = queryParams[i].split('=')[1];
      }
    }
    return linkObject;
  }

  isString = (x: any) => Object.prototype.toString.call(x) === "[object String]";

  showTooltip(event: MouseEvent, text: string, shouldTranslate: boolean = false) {
    if (text === null) return;

    this.tooltipText = shouldTranslate && typeof text === 'string' ? this.translate.instant(text) : text;
    const tooltip = document.getElementById(this.iReportTitle + 'hoverValue');
    const target = event.target as HTMLElement;
    if (tooltip && target) {
      tooltip.style.display = 'block';
      const targetRect = target.getBoundingClientRect();
      const tooltipWidth = tooltip.offsetWidth;
      const tooltipHeight = tooltip.offsetHeight;
      const left = targetRect.left + (targetRect.width / 1) - (tooltipWidth / 1);
      const top = targetRect.top - tooltipHeight - 30;

      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;
    }
  }

  hideTooltip() {
    this.tooltipText = '';
    const tooltip = document.getElementById(this.iReportTitle + 'hoverValue');
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  }

  private scheduleSummaryRowSync(): void {
    if (this.summaryRowSyncFrame !== null) {
      return;
    }

    this.summaryRowSyncFrame = window.requestAnimationFrame(() => {
      this.summaryRowSyncFrame = null;
      this.syncSummaryRowHeights();
    });
  }

  private syncSummaryRowHeights(): void {
    if (!this.summaryRows || this.summaryRows.length === 0) {
      return;
    }

    this.summaryRows.forEach((rowRef) => {
      const summaryCells = Array.from(rowRef.nativeElement.querySelectorAll<HTMLElement>('.report-datatable-summary-cell'));

      if (summaryCells.length === 0) {
        return;
      }

      summaryCells.forEach((cell) => {
        cell.style.minHeight = '';
      });

      const tallestHeight = Math.max(...summaryCells.map((cell) => cell.offsetHeight));

      summaryCells.forEach((cell) => {
        cell.style.minHeight = `${tallestHeight}px`;
      });
    });
  }
}